var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC400",
    d: "M8.023 1.749c.135-.49.83-.49.964 0l1.01 3.666a.5.5 0 0 0 .505.366l3.8-.171c.507-.023.721.637.298.917L11.425 8.62a.5.5 0 0 0-.193.593l1.338 3.56c.178.476-.383.884-.78.567l-2.973-2.372a.5.5 0 0 0-.624 0L5.221 13.34c-.397.317-.959-.091-.78-.567l1.337-3.56a.5.5 0 0 0-.193-.593L2.411 6.527c-.424-.28-.21-.94.298-.917l3.799.171a.5.5 0 0 0 .504-.366z"
  })));
};
export default SvgStar;